import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import {
  getConnectedCandidateList,
  applicationStatusChange,
} from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const ConnectedCandidate = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [applications, setApplication] = useState([]);
  const [btnloading, setBtnLoading] = useState(false);

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await getConnectedCandidateList();
        console.log(response);
        setApplication(response.data || []);
      } catch (err) {
        console.error("Error fetching Applications:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  const disconnectCandidate = async (applicationId) => {
    try {
      setBtnLoading(true);

      const res = await applicationStatusChange({
        applicationId,
        employerApprovalStatus: "Disconnected",
      });

      if (res.data.status) {
        toast.success(`Application disconnected successfully!`);

        setApplication((prev) =>
          prev.map((app) =>
            app.applicationId === applicationId
              ? { ...app, employerApprovalStatus: "Disconnected" }
              : app
          )
        );
      } else {
        toast.error(res.data.message || "Failed to update status");
      }
    } catch (err) {
      console.error("Error updating status:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Connected Candidate</h2>
          </div>

          {loading ? (
            <div className="text-center w-100 my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : applications.length === 0 ? (
            <div className="col-12">
              <div className="alert alert-info text-center">
                No Applications found.
              </div>
            </div>
          ) : (
            <table className="table mt-4 hj-table">
              <thead>
                <tr>
                  <th scope="col">Sl. No.</th>
                  <th scope="col">Job Post (Location)</th>
                  <th scope="col">Candidate</th>
                  <th scope="col">Phone & Email</th>
                  <th scope="col">Status</th>
                  <th scope="col">Hourly Rate</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((application, index) => (
                  <tr key={application.applicationId || index}>
                    <td>{index + 1}</td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>{application.jobTitle}</h5>
                        <p>
                          {application.city}, {application.state}
                        </p>
                      </div>
                    </td>

                    <td>
                      <a href="/candidate-profile">
                        <div className="transactiondetials d-flex align-items-center gap-3">
                          {application.image ? (
                            <img
                              src={application.image}
                              alt="icon"
                              className="astrologImg"
                            />
                          ) : (
                            <img
                              src="/assets/img/company-profiles/image-1.png"
                              alt="icon"
                              className="astrologImg"
                            />
                          )}

                          <div className="transactiondinfo">
                            <h5>{application.jobSeekerName}</h5>
                            <p>{application.jobProfile}</p>
                          </div>
                        </div>
                      </a>
                    </td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>+91 {application.phoneNumber}</h5>
                        <p>{application.email}</p>
                      </div>
                    </td>

                    <td>
                      <span
                        style={{
                          backgroundColor:
                            application.employerApprovalStatus === "Approved"
                              ? "#00e721"
                              : application.employerApprovalStatus === "Rejected"
                              ? "#e71b00"
                              : "#e7b100",
                          padding: "2px 12px",
                          borderRadius: "15px",
                          color: "#fff",
                        }}
                      >
                        {application.employerApprovalStatus || "Pending"}
                      </span>
                    </td>

                    <td>₹{application.hourlyRate}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="mainbtn dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Actions
                        </button>

                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item text-danger"
                              onClick={() => {
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "This will disconnect the candidate!",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#eb2d2dff",
                                  cancelButtonColor: "#6c757d",
                                  confirmButtonText: "Yes, disconnect!",
                                  cancelButtonText: "Cancel",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    disconnectCandidate(
                                      application.applicationId
                                    );
                                  }
                                });
                              }}
                              disabled={btnloading}
                            >
                              {btnloading ? (
                                <>
                                  <i className="fa fa-spinner fa-spin me-2"></i>
                                  Disconnecting...
                                </>
                              ) : (
                                "Disconnect"
                              )}
                            </button>
                          </li>

                          <li>
                            <a
                              className="dropdown-item"
                              href={`/employer/task-list/${application.applicationId}`}
                            >
                              View Task
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ConnectedCandidate;
